module.exports = __webpack_public_path__ + "img/cg_rabbit.4233f147.jpg";